module.exports = __webpack_public_path__ + "img/filedelete.4baa4446.gif";